module.exports = __webpack_public_path__ + "69fe335d74233adae46fb8f9d10f9e0b.svg";